export default __webpack_public_path__ + "static/media/syrie_fill.256edb83.svg";